import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const ConsumptionChartPanel = React.forwardRef(({ data }, ref) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 2000,
      easing: 'easeOutQuart'
    },
    plugins: {
      legend: {
        position: 'top',
        align: 'end',
        labels: {
          boxWidth: 10,
          usePointStyle: true,
          pointStyle: 'circle',
          font: {
            size: 11
          }
        }
      },
      title: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(17, 24, 39, 0.9)',
        padding: 12,
        cornerRadius: 8,
        titleFont: { size: 13 },
        bodyFont: { size: 12 },
        callbacks: {
          label: (context) => {
            return ` ${context.dataset.label}: ${context.raw.toFixed(2)} L`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: '#f3f4f6'
        },
        ticks: {
          font: { size: 10 }
        },
        title: {
          display: true,
          text: 'Litros',
          font: { size: 10 }
        }
      },
      x: {
        grid: {
          display: false
        },
        ticks: {
          font: { size: 10 }
        }
      }
    },
    interaction: {
      intersect: false,
      mode: 'index',
    },
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 flex flex-col h-full">
      <h3 className="text-sm font-semibold text-gray-900 mb-2">
        Consumo estimado
      </h3>
      <p className="text-xs text-gray-500 mb-4 h-8 overflow-hidden">
        Consumo (L) vs MES. Variación del consumo para el vehículo con mayor actividad.
      </p>

      <div className="flex-1 w-full min-h-0 relative flex flex-col justify-center">
        <div className="w-full h-full max-h-[400px]">
          {data ? (
            <Line ref={ref} options={options} data={data} />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center border border-dashed border-gray-300 rounded-lg text-xs text-gray-400">
              Seleccione un rango para ver datos
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

ConsumptionChartPanel.displayName = 'ConsumptionChartPanel';

export default ConsumptionChartPanel;
